import React, { Component } from "react";
import { Button } from "@progress/kendo-react-buttons";
import TovarFoto from "../../common/TovarFoto";
import { provideLocalizationService, registerForLocalization } from "@progress/kendo-react-intl";
import { Localization } from "../../common/Localization";
import { convertKodFarby } from "../../common/Helpers";
import { logController } from "../../../controllers/log.controller";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { CiarovyKodAllowedHandleKeys } from "../../../enums";
import { Zvuky } from "../../common/Zvuky";

class NovaFarbaDialogContent extends Component {
    state = {
        title: null
    };

    componentDidMount() {
        var localizationService = provideLocalizationService(this);

        var title =
            localizationService.toLanguageString("PríjemBalíka.Potvrdenie artikla a farby", "Potvrdenie artikla a farby") +
            ` - ${this.props.skenPolozka.cisloKarty}/${this.props.skenPolozka.farba} ${this.props.skenPolozka.popis} (balík ${this.props.response.packing})`;
        logController.logMessage(title);

        this.setState({
            title: title,
        });
    }

    potvrditHandler = () => {
        var localizationService = provideLocalizationService(this);
        logController.logMessage(
            this.state.title + " => " + localizationService.toLanguageString("PríjemNováFarba.Potvrdiť\r\nartikel/farbu", "Potvrdiť\r\nartikel/farbu").replace("\r\n", " ")
        );
        this.props.potvrdit(this.props.response);
        this.closeDialog();
    };

    zlyArtikelHandler = () => {
        var localizationService = provideLocalizationService(this);
        logController.logMessage(
            this.state.title + " => " + localizationService.toLanguageString("PríjemNováFarba.Zlý\r\nartikel/farba", "Zlý\r\nartikel/farba").replace("\r\n", " ")
        );
        this.props.zlyArtikel();
        this.closeDialog();
    };

    closeDialog = () => {
        this.props.toggleDialog(true);
    };

    render() {
        return (
            <div id="PrijemNovaFarbaDialog">
                <KeyboardEventHandler
                    handleKeys={CiarovyKodAllowedHandleKeys}
                    onKeyEvent={() => Zvuky.playChyba()}
                    handleFocusableElements={true}
                />
                <div className="row">
                    <div className="col-xs-9">
                        {this.props.skenPolozka.idVariant ? (
                            <TovarFoto idVariant={this.props.skenPolozka.idVariant} idKarta={this.props.skenPolozka.idKarta} bigFoto={true} />
                        ) : (
                            <div className="tovar-foto-big"></div>
                        )}
                    </div>
                    <div className="col-xs-3">
                        <div style={{ height: "310px" }}>
                            <Button icon="close" className="font-bold color-red" onClick={this.zlyArtikelHandler}>
                                <Localization
                                    messageKey={"PríjemNováFarba.Zlý\r\nartikel/farba"}
                                    defaultMessage={"Zlý\r\nartikel/farba"}
                                    replaceNewLines={true}
                                />
                            </Button>
                        </div>
                        <div
                            style={{
                                height: "100px",
                                padding: "5px",
                                backgroundColor: this.props.skenPolozka.kodFarby ? `#${convertKodFarby(this.props.skenPolozka.kodFarby)}` : ""
                            }}></div>
                        <div style={{ height: "70px", paddingTop: "20px" }}>
                            <Button icon="check" className="font-bold" onClick={this.potvrditHandler}>
                                <Localization
                                    messageKey={"PríjemNováFarba.Potvrdiť\r\nartikel/farbu"}
                                    defaultMessage={"Potvrdiť\r\nartikel/farbu"}
                                    replaceNewLines={true}
                                />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NovaFarbaDialogContent;

registerForLocalization(NovaFarbaDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijemBalika/NovaFarbaDialogContent.js